import * as React from "react";

;
export const ChevronUpSmll = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 10.06l-5.47 5.47-1.06-1.06L12 7.94l6.53 6.53-1.06 1.06L12 10.06z" fill="#100722" /></svg>;